/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../../services'

 
export const getAllOrgsAuthProviders = createAsyncThunk('org/getAllOrgsAuthProviders', async (_, { rejectWithValue }) => {
    try { 
        const data = await api.orgAuthProvider
        .getAllOrgsAuthProviders()
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getAllOrgsAuthProvidersByOrgID = createAsyncThunk('org/getAllOrgsAuthProvidersByOrgID', async (orgId, { rejectWithValue }) => {
    try { 
        const data = await api.orgAuthProvider
        .getAllOrgsAuthProvidersByOrgID(orgId)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getOrgAuthProviderHistory = createAsyncThunk('org/getOrgAuthProviderHistory', async (params, { rejectWithValue }) => {
    try { 
        const data = await api.orgAuthProvider.getOrgAuthProviderHistory(params)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
